import { MessageBar, MessageBarType, Stack, Text } from '@fluentui/react';
import { useAtomValue } from 'jotai';
import { appRoles } from '../../authConfig';
import { currentTenantNameAtom, profileDataAtom } from '../../atoms/authAtoms';
import { toConcreteTenantId } from './pricingSettings';
import TenantPricingOverrides from './TenantPricingOverrides';

const Pricing = () => {
  const { currentTenant, roles } = useAtomValue(profileDataAtom);
  const tenantName = useAtomValue(currentTenantNameAtom);
  const tenantId = toConcreteTenantId(currentTenant);
  const isAdmin = roles.includes(appRoles.Admin);

  return (
    <Stack tokens={{ childrenGap: 12 }} styles={{ root: { padding: 10 } }}>
      <Text variant="large">Tenant pricing overrides</Text>
      {tenantId === undefined ? (
        <MessageBar messageBarType={MessageBarType.info}>
          Select a tenant to manage its pricing overrides.
        </MessageBar>
      ) : (
        <>
          <Text>
            Tenant: {tenantName || tenantId}. Overrides replace the global base
            rate for matching item, currency, and date; tenant discounts and
            pricing tiers still apply.
          </Text>
          <TenantPricingOverrides
            key={tenantId}
            tenantId={tenantId}
            isAdmin={isAdmin}
          />
        </>
      )}
    </Stack>
  );
};

export default Pricing;
